import React, { Component } from "react";
import { connect } from "react-redux";
import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import ApplicationMessagesWrapper from "../inAppMessages/ApplicationMessagesWrapper";
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';
import Logger, { ALL_MESSAGES, LOG_LEVELS } from "../../utils/logger";
import Modal from "react-responsive-modal";
import FileSaver from "file-saver";
import _ from "underscore";
import HighlightOnInAppMessage from "../inAppMessages/HighlightOninAppMessage";
import FILING_CONTROLLER from "../../controllers/filing";
import CLIENT from "../../utils/restClient";
import { withFullStoryExclude } from "../../utils/fullStoryHelper";
import { SSelect } from '@avalara/skylab-sdk/react';

const FORM_NAME = "NL_SUBMIT_FILING";
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);
const MODAL_CLASSNAMES = {
  modal: "modal-full-width",
};

const SUBMIT_STATUS = Object.freeze({
  Success: "Success",
  Pending: "Pending",
  Error: "Error",
  Closed: "Closed",
  TechnicalProblem: "TechnicalProblem",
  LoginFailed: "LoginFailed",
});
const DIGIPORT_STATUS_CODE = Object.freeze({
  Success: 500,
  NotFound: 404,
  Closed: 1000,
  TechnicalProblem: 420,
});
const MAX_PASSWORD_LENGTH = 100;

const REPORT_TYPE = Object.freeze({
  VAT: "vat",
  ECL: "ecl",
});
const TECH_PROBLEM_EXTENDED_MESSAGE =
  "Please resubmit, if problem persists please log with support.";
const ERROR_STATUS_EXTENDED_MESSAGE =
  "Please correct and resubmit, if problem persists please log with support";

const DROPDOWN_VALUES = Object.freeze({
  taxonomyIdentifier: ["Omzetbelasting", "ICP", "Suppletie", "OSS"],
  identityRole: ["Intermediair", "Servicebureau", "Verantwoordingsplichtige"],
  taxonomyIdentifierUri: [
    "http://www.nltaxonomie.nl/nt20/bd/20251210/entrypoints/bd-rpt-ob-aangifte-2026.xsd",
    "http://www.nltaxonomie.nl/nt20/bd/20251210/entrypoints/bd-rpt-ob-suppletie-2026.xsd",
    "http://www.nltaxonomie.nl/nt20/bd/20251210/entrypoints/bd-rpt-icp-opgaaf-2026.xsd",
    "http://www.nltaxonomie.nl/nt19/bd/20241211/entrypoints/bd-rpt-ob-aangifte-2025.xsd",
    "http://www.nltaxonomie.nl/nt19/bd/20241211/entrypoints/bd-rpt-ob-suppletie-2025.xsd",
    "http://www.nltaxonomie.nl/nt19/bd/20241211/entrypoints/bd-rpt-icp-opgaaf-2025.xsd",
    "http://www.nltaxonomie.nl/nt18/bd/20231213/entrypoints/bd-rpt-icp-opgaaf-2024.xsd",
    "http://www.nltaxonomie.nl/nt18/bd/20231213/entrypoints/bd-rpt-ob-suppletie-2024.xsd",
    "http://www.nltaxonomie.nl/nt18/bd/20231213/entrypoints/bd-rpt-ob-aangifte-2024.xsd",
    "http://www.nltaxonomie.nl/nt17/bd/20221207/entrypoints/bd-rpt-icp-opgaaf-2023.xsd",
    "http://www.nltaxonomie.nl/nt17/bd/20221207/entrypoints/bd-rpt-ob-suppletie-2023.xsd",
    "http://www.nltaxonomie.nl/nt17/bd/20221207/entrypoints/bd-rpt-ob-aangifte-2023.xsd",
    "http://www.nltaxonomie.nl/nt16/bd/20211208/entrypoints/bd-rpt-icp-opgaaf-2022.xsd",
    "http://www.nltaxonomie.nl/nt16/bd/20211208/entrypoints/bd-rpt-ob-suppletie-2022.xsd",
    "http://www.nltaxonomie.nl/nt16/bd/20211208/entrypoints/bd-rpt-ob-aangifte-2022.xsd",
    "http://www.nltaxonomie.nl/nt15/bd/20210915/entrypoints/bd-rpt-oss.xsd",
    "http://www.nltaxonomie.nl/nt15/bd/20201209/entrypoints/bd-rpt-ob-suppletie-2021.xsd",
    "http://www.nltaxonomie.nl/nt15/bd/20201209/entrypoints/bd-rpt-icp-opgaaf-2021.xsd",
    "http://www.nltaxonomie.nl/nt15/bd/20201209/entrypoints/bd-rpt-ob-aangifte-2021.xsd",
    "http://www.nltaxonomie.nl/nt14/bd/20191211/entrypoints/bd-rpt-ob-suppletie-2020.xsd",
    "http://www.nltaxonomie.nl/nt14/bd/20191211/entrypoints/bd-rpt-icp-opgaaf-2020.xsd",
    "http://www.nltaxonomie.nl/nt14/bd/20191211/entrypoints/bd-rpt-ob-aangifte-2020.xsd",
    "http://www.nltaxonomie.nl/nt13/bd/20181212/entrypoints/bd-rpt-ob-suppletie-2019.xsd",
    "http://www.nltaxonomie.nl/nt13/bd/20181212/entrypoints/bd-rpt-icp-opgaaf-2019.xsd",
    "http://www.nltaxonomie.nl/nt13/bd/20181212/entrypoints/bd-rpt-ob-aangifte-2019.xsd",
    "http://www.nltaxonomie.nl/nt12/bd/20171213/entrypoints/bd-rpt-ob-suppletie-2018.xsd",
    "http://www.nltaxonomie.nl/nt12/bd/20171213/entrypoints/bd-rpt-icp-opgaaf-2018.xsd",
    "http://www.nltaxonomie.nl/nt12/bd/20171213/entrypoints/bd-rpt-ob-aangifte-2018.xsd",
    "http://www.nltaxonomie.nl/nt11/bd/20161207/entrypoints/bd-rpt-ob-suppletie-2017.xsd",
    "http://www.nltaxonomie.nl/nt11/bd/20161207/entrypoints/bd-rpt-icp-opgaaf-2017.xsd",
    "http://www.nltaxonomie.nl/nt11/bd/20161207/entrypoints/bd-rpt-ob-aangifte-2017.xsd",
    "http://www.nltaxonomie.nl/10.0/report/bd/entrypoints/bd-rpt-ob-aangifte-2016.xsd",
    "http://www.nltaxonomie.nl/10.0/report/bd/entrypoints/bd-rpt-icp-opgaaf-2016.xsd",
    "http://www.nltaxonomie.nl/9.0/report/bd/entrypoints/bd-rpt-ob-aangifte-2015.xsd",
    "http://www.nltaxonomie.nl/9.0/report/bd/entrypoints/bd-rpt-icp-opgaaf-2015.xsd",
    "http://www.nltaxonomie.nl/8.0/report/bd/entrypoints/bd-rpt-ob-aangifte-2014.xsd",
    "http://www.nltaxonomie.nl/8.0/report/bd/entrypoints/bd-rpt-icp-opgaaf-2014.xsd",
  ],
});
const AUDIT_FILE_NAME = "AuditReport.html";

class NLSubmitFiling extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmitPopupOpen: false,
      isSubmitDisable: false,
      showExtendedError: false,
      showExtendedTechProblem: false,
    };
    this.userNameFieldChange = this.userNameFieldChange.bind(this);
    this.onPasswordFieldChange = this.onPasswordFieldChange.bind(this);
    this.reportType = this.props.isVATFiling
      ? REPORT_TYPE.VAT
      : REPORT_TYPE.ECL;
  }

  onOpenModal() {
    this.clearFields();
    log.clearAllDictionaryErrors();
    CLIENT.getNLSubmissionStatus(
      this.reportType,
      this.props.vatnumber,
      this.props.fromDate,
      this.props.toDate
    )
      .then((response) => {
        this.setFilingStatusBeforeSubmit(response);
      })
      .catch((err) => {
        log.debug("getNLSubmissionStatus error: ", err);
      });
  }

  setFilingStatusBeforeSubmit(response) {
    if (response && response.status === DIGIPORT_STATUS_CODE.NotFound) {
      //this means fresh transaction,so show dialog box and enable submit
      this.setState({ isSubmitPopupOpen: true, isSubmitDisable: false });
    } else {
      let currentStatus = this.determineFilingStatus(response);
      switch (currentStatus) {
        case SUBMIT_STATUS.Success:
          //this means already successful transaction,no need to show dialong box
          // log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_NL_ALREADY_SUCCESS);
          this.setState({ isSubmitPopupOpen: false });
          this.props.onApprove();
          break;
        case SUBMIT_STATUS.Pending:
          //this means already Pending transaction,need to show dialog box and disbale submit
          log.setDictionaryMessage(
            ALL_MESSAGES.SUBMIT_FILING_NL_CURRENT_PENDING_STATES
          );
          this.setState({ isSubmitPopupOpen: true, isSubmitDisable: true });
          break;
        case SUBMIT_STATUS.Closed:
          this.setState({ isSubmitPopupOpen: true, isSubmitDisable: false });
          break;
        case SUBMIT_STATUS.TechnicalProblem:
          //this means error transaction,need to show dialog box and enable submit
          log.setDictionaryMessage(
            ALL_MESSAGES.SUBMIT_FILING_NL_CURRENT_ERROR_STATES,
            response.statusDescription
          );
          this.setState({
            isSubmitPopupOpen: true,
            isSubmitDisable: false,
            showExtendedTechProblem: true,
          });
          break;
        case SUBMIT_STATUS.Error:
          //this means error transaction,need to show dialog box and enable submit
          log.setDictionaryMessage(
            ALL_MESSAGES.SUBMIT_FILING_NL_CURRENT_ERROR_STATES,
            response.errorDescription
          );
          this.setState({
            isSubmitPopupOpen: true,
            isSubmitDisable: false,
            showExtendedError: true,
          });
          break;
        default:
          //this means error transaction,need to show dialog box and enable submit
          log.setDictionaryMessage(
            ALL_MESSAGES.SUBMIT_FILING_NL_CURRENT_ERROR_STATES,
            response.errorDescription
          );
          this.setState({
            isSubmitPopupOpen: true,
            isSubmitDisable: false,
            showExtendedError: true,
          });
      }
    }
  }

  eligibalForAuditReport(response) {
    let generateAudit = true;
    let currentStatus = this.determineFilingStatus(response);
    switch (currentStatus) {
      case SUBMIT_STATUS.Success:
        //log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_NL_SUCCESS);
        this.props.onApprove();
        break;
      case SUBMIT_STATUS.Pending:
        log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_NL_PENDING);
        break;
      case SUBMIT_STATUS.LoginFailed:
        generateAudit = false;
        log.setDictionaryMessage(
          ALL_MESSAGES.SUBMIT_FILING_NL_ERROR,
          response.message
        );
        break;
      case SUBMIT_STATUS.Error:
        log.setDictionaryMessage(
          ALL_MESSAGES.SUBMIT_FILING_NL_ERROR,
          `${response.errorDescription}. ${ERROR_STATUS_EXTENDED_MESSAGE}`
        );
        break;
      case SUBMIT_STATUS.TechnicalProblem:
        log.setDictionaryMessage(
          ALL_MESSAGES.SUBMIT_FILING_NL_ERROR,
          `${response.statusDescription}. ${TECH_PROBLEM_EXTENDED_MESSAGE}`
        );
        break;
      default:
        log.setDictionaryMessage(
          ALL_MESSAGES.SUBMIT_FILING_NL_ERROR,
          `${response.errorDescription}. ${ERROR_STATUS_EXTENDED_MESSAGE}`
        );
    }
    return generateAudit;
  }
  determineFilingStatus(response) {
    if (
      response &&
      response.errorCode == "" &&
      response.statusCode === DIGIPORT_STATUS_CODE.Success
    ) {
      return SUBMIT_STATUS.Success;
    }
    if (
      response &&
      response.statusCode === DIGIPORT_STATUS_CODE.TechnicalProblem
    ) {
      return SUBMIT_STATUS.TechnicalProblem;
    }
    if (response && response.statusCode === DIGIPORT_STATUS_CODE.Closed) {
      return SUBMIT_STATUS.Closed;
    }
    if (
      response &&
      !_.has(response, "statusCode") &&
      !_.has(response, "errorCode") &&
      _.has(response, "message")
    ) {
      return SUBMIT_STATUS.LoginFailed;
    }
    if (response && response.errorCode === "") {
      return SUBMIT_STATUS.Pending;
    }

    return SUBMIT_STATUS.Error;
  }
  onCloseModal() {
    log.clearAllDictionaryErrors();
    this.setState({ isSubmitPopupOpen: false });
  }
  clearFields() {
    this.setState({
      digiPortPassword: "",
      digiPortUserName: "",
      showExtendedError: false,
      showExtendedTechProblem: false,
    });
  }
  onSubmitReport() {
    let isValid = true;
    if (_.isEmpty(this.state.digiPortUserName.trim())) {
      log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_NL_BLANK_USERNAME);
      isValid = false;
    }
    if (_.isEmpty(this.state.digiPortPassword)) {
      log.setDictionaryMessage(ALL_MESSAGES.SUBMIT_FILING_NL_BLANK_PASSWORD);
      isValid = false;
    } else if (this.state.digiPortPassword.length > MAX_PASSWORD_LENGTH) {
      log.setDictionaryMessage(ALL_MESSAGES.MAX_LENGTH_PASSWORD);
      isValid = false;
    }

    if (isValid) {
      log.clearAllDictionaryErrors();
      this.setState({ isSubmitPopupOpen: false });

      const callback = (response) => {
        if (this.eligibalForAuditReport(response)) {
          if (response.auditReportContent) {
            let data = atob(response.auditReportContent);
            let blob = new Blob([data], { type: "text/plain" });
            FileSaver.saveAs(blob, AUDIT_FILE_NAME);
          } else {
            log.debug("auditReportContent data is blank ");
          }
        }
      };

      let filingParamsNL = {
        reportFileURL: this.props.uri.split("/").pop(),
        reportFileName: `${this.props.filename}.${this.props.documentExtension}`,
        vatNumber: this.props.vatnumber,
        digiPortUserName: this.state.digiPortUserName,
        digiPortPassword: btoa(this.state.digiPortPassword),
        identityRole: this.state.selectedIdentityRole,
        taxonomyIdentifier: this.state.selectedTaxonomyIdentifier,
        taxonomyURI: this.state.selectedTaxonomyIdentifierUri,
        fromDate: this.props.fromDate,
        toDate: this.props.toDate,
      };

      this.props.doSubmitNLReport(filingParamsNL, this.reportType, callback);
    }
  }
  UNSAFE_componentWillMount() {
    log.clearAllDictionaryErrors();
  }

  componentDidMount() {
    this.setState({
      filteredTaxonomyIdentifierUri: this.getFilteredTaxonomyIdentifierUri(
        DROPDOWN_VALUES.taxonomyIdentifier[0]
      ),
      selectedTaxonomyIdentifierUri: this.getFilteredTaxonomyIdentifierUri(
        DROPDOWN_VALUES.taxonomyIdentifier[0]
      )[0],
      selectedTaxonomyIdentifier: DROPDOWN_VALUES.taxonomyIdentifier[0],
      selectedIdentityRole: DROPDOWN_VALUES.identityRole[2],
    });
  }

  getFilteredTaxonomyIdentifierUri(taxonomyfilter) {
    let taxonomyIdentifierUri = Object.assign(
      {},
      DROPDOWN_VALUES.taxonomyIdentifierUri
    );
    let result;
    if (taxonomyfilter === "Omzetbelasting") {
      result = _.filter(taxonomyIdentifierUri, function (t) {
        return t.includes("aangifte");
      });
    }
    if (taxonomyfilter === "ICP") {
      result = _.filter(taxonomyIdentifierUri, function (t) {
        return t.includes("opgaaf");
      });
    }
    if (taxonomyfilter === "Suppletie") {
      result = _.filter(taxonomyIdentifierUri, function (t) {
        return t.includes("suppletie");
      });
    }
    if (taxonomyfilter === "OSS") {
      result = _.filter(taxonomyIdentifierUri, function (t) {
        return t.includes("oss");
      });
    }

    return result;
  }
  dropdownSelectionChangeHandler(name) {
    return (e) => {
      const selectedValue = e.detail.item.value;
      if (name === "IdentityRole") {
        this.setState({ selectedIdentityRole: selectedValue });
      }
      if (name === "TaxonomyIdentifier") {
        this.setState({
          selectedTaxonomyIdentifier: selectedValue,
          filteredTaxonomyIdentifierUri: this.getFilteredTaxonomyIdentifierUri(
            selectedValue
          ),
          selectedTaxonomyIdentifierUri: this.getFilteredTaxonomyIdentifierUri(
            selectedValue
          )[0],
        });
      }
      if (name === "TaxonomyIdentifierUri") {
        this.setState({ selectedTaxonomyIdentifierUri: selectedValue });
      }
    };
  }

  getDropDownComponent(name, data) {
    if (!data) {
      return <div></div>;
    }

    const optionsList = data.map((key) => ({
      key: key,
      value: key,
      label: key,
      selected: this.state["selected" + name] === key
    }));

    return (
      <SSelect
        inputId={`nl-submit-${name.toLowerCase()}`}
        name={name}
        optionsList={optionsList}
        multiple={false}
        onS-select={this.dropdownSelectionChangeHandler(name).bind(this)}
      />
    );
  }
  userNameFieldChange() {
    return (evt) => {
      if (!_.isEmpty(evt.target.value.trim())) {
        log.clearDictionaryError(ALL_MESSAGES.SUBMIT_FILING_NL_BLANK_USERNAME);
      }
      this.setState({ digiPortUserName: evt.target.value });
    };
  }
  onPasswordFieldChange() {
    return (evt) => {
      if (!_.isEmpty(evt.target.value)) {
        log.clearDictionaryError(ALL_MESSAGES.SUBMIT_FILING_NL_BLANK_PASSWORD);
        if (evt.target.value.length <= MAX_PASSWORD_LENGTH) {
          log.clearDictionaryError(ALL_MESSAGES.MAX_LENGTH_PASSWORD);
        }
      }
      this.setState({ digiPortPassword: evt.target.value });
    };
  }

  render() {
    log.debug("render(): ", this.props);

    return (
      <>
        <ApplicationMessagesWrapper
          messageIds={[ALL_MESSAGES.SUBMIT_FILING_NL_ERROR]}
          messageType="applicationError"
        />
        <ApplicationMessagesWrapper
          messageIds={[
            ALL_MESSAGES.SUBMIT_FILING_NL_SUCCESS,
            ALL_MESSAGES.SUBMIT_FILING_NL_ALREADY_SUCCESS,
          ]}
          messageType="applicationSuccess"
        />
        <ApplicationMessagesWrapper
          messageIds={[ALL_MESSAGES.SUBMIT_FILING_NL_PENDING]}
          messageType="applicationWarning"
        />
        {/* Do not put the ApplicationMessages under the button as this will output a row after the button, pushing any other component next to this button down and displaying the message inbetween */}
        <ReadOnlyWrapper>
          <button className="primary mb20" onClick={() => this.onOpenModal()}>
            {this.props.isVATFiling ? (
              <LanguageStringResolver string="submitFilingNL_VR_Submit" />
            ) : (
              <LanguageStringResolver string="submitFilingNL_ECL_Submit" />
            )}
          </button>
        </ReadOnlyWrapper>
        <Modal
          center
          classNames={MODAL_CLASSNAMES}
          open={this.state.isSubmitPopupOpen}
          onClose={() => this.onCloseModal()}
        >
          <div>
            <h2>
              <LanguageStringResolver string="submitFilingNL_Title" />
            </h2>
            <ApplicationMessagesWrapper
              scopes={[FORM_NAME]}
              messageIds={[
                ALL_MESSAGES.SUBMIT_FILING_NL_BLANK_USERNAME,
                ALL_MESSAGES.SUBMIT_FILING_NL_BLANK_PASSWORD,
                ALL_MESSAGES.MAX_LENGTH_PASSWORD,
                ALL_MESSAGES.SUBMIT_FILING_NL_CURRENT_ERROR_STATES,
              ]}
              messageType="applicationError"
            />
            <ApplicationMessagesWrapper
              scopes={[FORM_NAME]}
              messageIds={[
                ALL_MESSAGES.SUBMIT_FILING_NL_CURRENT_PENDING_STATES,
              ]}
              messageType="applicationWarning"
            />
            {this.state.showExtendedError ? (
              <p className="mb5 bold">{ERROR_STATUS_EXTENDED_MESSAGE}</p>
            ) : null}
            {this.state.showExtendedTechProblem ? (
              <p className="mb5 bold">{TECH_PROBLEM_EXTENDED_MESSAGE}</p>
            ) : null}

            <fieldset>
              <s-row>
                <s-col span="7">
                  <HighlightOnInAppMessage
                    scopes={[FORM_NAME]}
                    messageIds={[ALL_MESSAGES.SUBMIT_FILING_NL_BLANK_USERNAME]}
                  >
                    <label className="mt10">
                      <LanguageStringResolver string="submitFilingNL_Username" />
                      :{" "}
                    </label>
                    <input
                      onChange={this.userNameFieldChange()}
                      name="digiportUsername"
                      value={this.state.digiPortUserName}
                    />
                  </HighlightOnInAppMessage>
                  <HighlightOnInAppMessage
                    scopes={[FORM_NAME]}
                    messageIds={[
                      ALL_MESSAGES.SUBMIT_FILING_NL_BLANK_PASSWORD,
                      ALL_MESSAGES.MAX_LENGTH_PASSWORD,
                    ]}
                  >
                    <label className="mt10">
                      <LanguageStringResolver string="submitFilingNL_Password" />
                      :{" "}
                    </label>
                    <input
                      type="password"
                      className={withFullStoryExclude()}
                      onChange={this.onPasswordFieldChange()}
                      name="digiportPassword"
                      value={this.state.digiPortPassword}
                    />
                  </HighlightOnInAppMessage>
                  <label className="mt10">
                    <LanguageStringResolver string="submitFilingNL_IdentityRole" />
                    :{" "}
                  </label>
                  {this.getDropDownComponent(
                    "IdentityRole",
                    DROPDOWN_VALUES.identityRole
                  )}
                  <label className="mt10">
                    <LanguageStringResolver string="submitFilingNL_TaxonomyIdentifier" />
                    :{" "}
                  </label>
                  {this.getDropDownComponent(
                    "TaxonomyIdentifier",
                    DROPDOWN_VALUES.taxonomyIdentifier
                  )}
                </s-col>
              </s-row>
              <s-row>
                <s-col span="12">
                  <label className="mt10">
                    <LanguageStringResolver string="submitFilingNL_TaxonomyIdentifierUri" />
                    :{" "}
                  </label>
                  {this.getDropDownComponent(
                    "TaxonomyIdentifierUri",
                    this.state.filteredTaxonomyIdentifierUri
                  )}
                </s-col>
              </s-row>
            </fieldset>
            <br />
            <p className="mb5 bold">
              <LanguageStringResolver string="submitFilingNL_StaticWarning" />
            </p>
            <br />
            <a
              className={
                this.state.isSubmitDisable
                  ? "button primary disabled"
                  : "button primary"
              }
              onClick={this.onSubmitReport.bind(this)}
            >
              <LanguageStringResolver string="submitFilingDE_Submit" />
            </a>
            <a className="button secondary" onClick={() => this.onCloseModal()}>
              <LanguageStringResolver string="submitFiling_cancel" />
            </a>
          </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchersToProps(dispatch) {
  return {
    doSubmitNLReport: (filingParamsNL, reportType, callback) => {
      log.debug("doSubmitNLReport() in dispatch");
      dispatch(
        FILING_CONTROLLER.doSubmitNLReport(filingParamsNL, reportType, callback)
      );
    },
  };
}

export default connect(mapStateToProps, mapDispatchersToProps)(NLSubmitFiling);
